
import Button from '../../../components/base/Button';

export default function CTASection() {
  return (
    <section className="py-20 bg-[#e18033]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          Ready to Bring Your Project to Life?
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          Get professional CAD designs, BIM models, and technical drawings that meet the highest industry standards. Let's discuss your project requirements today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          {/* <Button variant="secondary" size="lg" className="bg-white text-[#e18033] hover:bg-[#dbcfbf]">
            Request a Quote
          </Button> */}
            <a href='/contact'><Button 
            variant="outline" 
            size="lg" 
            className="border-white text-white hover:bg-[#e18033]"
          >
            Contact Us
          </Button></a>
        </div>
        
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 text-white">
          <div className="text-center">
            <div className="text-3xl font-bold mb-2">500+</div>
            <div className="text-white/80">Projects Completed</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold mb-2">50+</div>
            <div className="text-white/80">Happy Clients</div>
          </div>
          <div className="text-center">
            <div className="text-3xl font-bold mb-2">24/7</div>
            <div className="text-white/80">Support Available</div>
          </div>
        </div>
      </div>
    </section>
  );
}
